module.exports = __webpack_public_path__ + "static/media/glanum_nymphaeum.d663de59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_nymphaeum.png
// module id = 721
// module chunks = 0